import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'timeTableScheduler';

export const getFullTimeTable = (reqData: Object) => {
  return axios.get(API_URL + '/fetch-published-timetables', { params: reqData });
};

export const generateTimetable = (reqData: Object) => {
  return axios.post(API_URL + '/generate', reqData);
};
